import { render, staticRenderFns } from "./pub_home.vue?vue&type=template&id=53b10d8f&scoped=true"
import script from "./pub_home.vue?vue&type=script&lang=js"
export * from "./pub_home.vue?vue&type=script&lang=js"
import style0 from "./pub_home.vue?vue&type=style&index=0&id=53b10d8f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53b10d8f",
  null
  
)

export default component.exports